import { sidebarAction } from "../../actionTypes";

export const toogleSidebar = () => {
	return dispatch => {
		dispatch({
			type: sidebarAction.TOOGLE_SIDEBAR,
		});
	};
};
